import { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./General/ScrollToTop";

import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Privacypolicy from "./components/Privacypolicy";
import Header from "./General/Header";
import Footer from "./General/Footer";
import Scollerup from "./General/Scollerup";
import Loading from "./General/Loading"

import AdminLogin from "./AdminPanel/AdminLogin";
import AdminDashboard from "./AdminPanel/AdminDashboard";
import AdminSideBar from "./AdminPanel/AdminSideBar";
import './App.css';
import ManageDealer from "./AdminPanel/Dealers/ManageDealer";
import { Toaster } from "react-hot-toast";
import Inventory from "./AdminPanel/Inventory/Inventory";
import User from "./AdminPanel/User/User";
import Banner from "./AdminPanel/Setting/Banner";
import Driver from "./AdminPanel/Driver/Driver";
import MachineList from "./AdminPanel/Dealers/MachineList";
import PayementHistroy from "./AdminPanel/PaymentHistory/PayementHistroy";
import DriverEnquiry from "./AdminPanel/PaymentHistory/DriverEnquiry";
import WebEnquiry from "./AdminPanel/WebEnquiry/WebEnquiry";
import CustomerEnquiry from "./AdminPanel/CustomerEnquiry/CustomerEnquiry";
import CustomerSphere from "./AdminPanel/CustomerSpehereEnq/CustomerSphere";
import DealerPartsQuotation from "./AdminPanel/CustomerSpehereEnq/DealerPartsQuotation";
import DriverWithdrwal from "./AdminPanel/DriverWithdrawal/DriverWithdrwal";
import Rating from "./AdminPanel/Rating/Rating";
import Support from "./AdminPanel/CustomerSupport/Support";
import Pincode from "./AdminPanel/Master/Pincode";
import DealerWithdrawal from "./AdminPanel/DealerWithdrawal/DealerWithdrawal";
import CategoryMaster from "./AdminPanel/Master/CategoryMaster";
import Master_Question from "./AdminPanel/Chatbot/Master_Question";

import PageNotFound from "./General/PsgeNotFound";
import { useLocation } from "react-router-dom";
import Chatbot_Suggestion from "./AdminPanel/Chatbot/Chatbot_Suggestion";
import Activity from "./AdminPanel/Rating/Activity";
import Chatbot_History from "./AdminPanel/Chatbot/Chatbot_History";
import BusinessCategory from "./AdminPanel/Master/BusinessCategory";


function App() {
  const [isAdmin, setIsAdmin] = useState(
    localStorage.getItem("isAdmin") === "true"
  );
const location = useLocation();


  const storedUserData = localStorage.getItem("userData");
  const parsedData = storedUserData ? JSON.parse(storedUserData) : null;



  const userData = parsedData?.result || null;
  // const userData = parsedData || null;


  const token = parsedData?.token || null;



  const [collapsed, setCollapsed] = useState(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loading />;
  }

  const validRoutes = [
  "/",
  "/about",
  "/contact",
  "/privacy-policy",
  "/admin-login",
];

const showLayout = validRoutes.includes(location.pathname);


  return (

    <>
    <ScrollToTop />
     

      {!isAdmin && (
  <>
    <Toaster position="top-center" />

    {showLayout && <Header />}

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy-policy" element={<Privacypolicy />} />
      <Route
        path="/admin-login"
        element={<AdminLogin setIsAdmin={setIsAdmin} />}
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>

    {showLayout && <Scollerup />}
    {showLayout && <Footer />}
  </>
)}


      {isAdmin && (
        <>
          <Toaster position="top-center" />
          <div className="admin-layout">
            <AdminSideBar
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />

            <div
              className="dashboard-sidebar-right"
              style={{
                // marginLeft: collapsed ? "70px" : "220px",
                width: collapsed ? "calc(100% - 70px)" : "calc(100% - 220px)",
                minHeight: "100vh",
                padding: "20px",
                background: "#f8f9fa",
                transition: "0.3s"
              }}
            >
              <Routes>
                <Route
                  path="/"
                  element={<AdminDashboard token={token} />}
                />
                <Route
                  path="/admin/admin-dashboard"
                  element={<AdminDashboard token={token} />}
                />
                {/* Dealer */}
                <Route path="/admin/dealers" element={<ManageDealer token={token} />} />
                <Route path="/admin/machine-list" element={<MachineList token={token} />} />


                {/* user */}
                <Route path="/admin/users" element={<User token={token} />} />

                {/*Driver  */}
                <Route path="/admin/driver" element={<Driver token={token} />} />


                <Route path="/admin/inventory" element={<Inventory userData={userData} token={token} />} />

                {/* Payment History */}
                <Route path="/admin/payment-history" element={<PayementHistroy token={token} />} />
                <Route path="/admin/enquiry" element={<DriverEnquiry userData={userData} token={token} />} />

                {/*Setting  */}
                <Route path="/admin/banner" element={<Banner userData={userData} token={token} />} />

                {/*Web Enquiry  */}
                <Route path="/admin/web-query" element={<WebEnquiry userData={userData} token={token} />} />

                {/*Customer Machine Enquiry  */}

                <Route path="/admin/customer-enq" element={<CustomerEnquiry userData={userData} token={token} />} />

                {/* Cusomer Spehere part Enquiry */}
                <Route path="/admin/customer-sphere" element={<CustomerSphere userData={userData} token={token} />} />
                <Route path="/admin/dealer-quotation" element={<DealerPartsQuotation userData={userData} token={token} />} />

                {/* Driver Withdrawal */}
                <Route path="/admin/withdrawal" element={<DriverWithdrwal userData={userData} token={token} />} />

                     {/* Dealer Withdrawal */}
                <Route path="/admin/walltet" element={<DealerWithdrawal userData={userData} token={token} />} />

                {/* Rating */}
            <Route path="/admin/rating" element={<Rating userData={userData} token={token} />} />

               {/* help and support */}
            <Route path="/admin/help-support" element={<Support userData={userData} token={token} />} />


            {/*Pinocde master */}
            <Route path="/admin/master" element={<Pincode userData={userData} token={token} />} />
            <Route path="/admin/category" element={<CategoryMaster userData={userData} token={token} />} />
        <Route path="/admin/business" element={<BusinessCategory userData={userData} token={token} />} />
       


            {/* Chatbot */}
              <Route path="/admin/question" element={<Master_Question userData={userData} token={token} />} />
               <Route path="/admin/suggestion" element={<Chatbot_Suggestion userData={userData} token={token} />} />
             <Route path="/admin/chat-history" element={<Chatbot_History userData={userData} token={token} />} />

             <Route path="/admin/activity" element={<Activity userData={userData} token={token} />} />
               
         
              </Routes>

            </div>
          </div>

        </>

      )}

    </>
  );
}
export default App;